
import { Ball, SimulationConfig, Vector2D } from '../types';
import { AUDIO } from '../services/AudioService';

export class SpectrumLogic {
  public static update(
    deltaTime: number,
    config: SimulationConfig,
    freqData: Uint8Array,
    persistentSpectrumBoost: Float32Array,
    persistentSpectrumTarget: Float32Array,
    balls: Ball[]
  ) {
    const hasAudio = freqData && freqData.length > 0;
    const shrinkRate = config.rhythmicSpectrumShrinkRate || 0.05;
    const timeFactor = deltaTime / 16.67;
    const audioSens = config.rhythmicSpectrumAudioSensitivity ?? 1.0;
    const spatiality = config.rhythmicSpectrumAudioSpatiality ?? 0.0;

    for (let i = 0; i < 256; i++) {
        let audioTarget = 0;
        if (hasAudio) {
            const binIndex = Math.floor((i / 256) * freqData.length);
            const audioVal = (freqData[binIndex] / 255) * audioSens;
            audioTarget = Math.pow(audioVal, 0.25) * 3.0;

            if (spatiality > 0) {
                const barAngle = (i / 256) * Math.PI * 2 - Math.PI;
                let minAngleDiff = Math.PI;
                
                balls.forEach(b => {
                    const ballAngle = Math.atan2(b.pos.y, b.pos.x);
                    let diff = Math.abs(barAngle - ballAngle);
                    if (diff > Math.PI) diff = 2 * Math.PI - diff;
                    if (diff < minAngleDiff) minAngleDiff = diff;
                });

                const spatialFactor = Math.max(1 - spatiality, Math.pow(Math.cos(Math.min(Math.PI/2, minAngleDiff * 1.5)), 2));
                audioTarget *= spatialFactor;
            }
        }

        const collisionTarget = persistentSpectrumTarget[i];
        const collisionActivity = config.rhythmicSpectrumGlobalAudio ? 1.0 : Math.min(1.0, collisionTarget * 2.0);
        const gatedAudioTarget = audioTarget * collisionActivity;
        
        const finalTarget = Math.max(gatedAudioTarget, collisionTarget);
        const current = persistentSpectrumBoost[i];
        
        if (finalTarget > current) {
            persistentSpectrumBoost[i] = finalTarget;
        } else {
            const step = (current - finalTarget) * shrinkRate * timeFactor;
            persistentSpectrumBoost[i] = Math.max(finalTarget, current - Math.max(0.005 * timeFactor, step));
        }
        
        persistentSpectrumTarget[i] *= Math.pow(0.95, timeFactor);
        if (persistentSpectrumTarget[i] < 0.01) persistentSpectrumTarget[i] = 0;
    }
  }
}
